import { render } from "./ShiftTable.vue?vue&type=template&id=83d47bbe"
import script from "./ShiftTable.vue?vue&type=script&lang=js"
export * from "./ShiftTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__